export default "__VITE_ASSET__23692e4b__"